import { Money, PatientBalance } from "./Balance";
import * as React from "react";
import "./PatientBalanceView.scss";
import UserCardSmall from "../commons/components/user/UserCardSmall";
import { getLocalePrice } from "../commons/utils/text-rendering";

export default function PatientBalanceView({ patient, balance }: PatientBalance) {
  return (
    <div className={"balance"}>
      <div className={"contact-card"}>
        <UserCardSmall userInfo={patient} />
      </div>
      <table>
        <tbody>
          {balance.currentDue && (
            <tr>
              <td>{i18n["Page.Payment.Balances.Balance.Current"]}</td>
              <th className={"current"}>{formatMoney(balance.currentDue)}</th>
            </tr>
          )}
          <tr>
            <td>{i18n["Page.Payment.Balances.Balance.Remaining"]}</td>
            <th className={"remaining"}>{formatMoney(balance.totalDue)}</th>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function formatMoney(money: Money): String {
  return getLocalePrice(money.amount, money.currency);
}
